import { Field } from 'redux-form';

export class DefaultField extends Field<any> {}



// WEBPACK FOOTER //
// ./src/components/form/DefaultField/DefaultField.tsx